import axios from "@axios";
import store from "@/store";

export default {
  namespaced: true,
  state: {
    items: [],
    selectAll: false
  },
  getters: {
    getItems(state) {
      return state.items
    },
    getSelectedItems(state) {
      return state.items.map(camera => ({
        value: camera.id,
        label: camera.name,
      }))
    },
    getSelectAll(state) {
      return state.selectAll
    },
  },
  mutations: {
    setData(state, value) {
      state.items = value
    },
    setSelectAll(state, value) {
      state.selectAll = value;
    },
  },
  actions: {
    async export({commit}, params) {
      const response = await axios.get("v1/securos_camera", {
        params,
        responseType: params?.action == "export" ? "blob" : "json",
      });
      if (!response.data) {
        return [];
      }
      if (params?.action == "export") {
        const url = window.URL.createObjectURL(
          new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          })
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          response.headers["content-disposition"].split("filename=")[1]
        );
        document.body.appendChild(link);
        link.click();
        link.remove();

        const notification = {
          id: response.headers["content-disposition"].split("filename=")[1],
          progress: 100,
          completed: true,
          view: "SecurOs cameras",
          url: url,
          download: response.headers["content-disposition"].split("filename=")[1],
          title: "Reporte de cámaras SecurOs",
          body: "Descarga completa",
          error: false,
          timestamp:
            new Date().toLocaleDateString() + " " + new Date().toLocaleTimeString(),
        };
        store.dispatch("grid/updateDownloadNotification", notification);
      } else {
        commit("setData", response.data.data);
        return response.data;
      }
    },
    async getAll({commit}, params) {
      const {data} = await axios.get('v1/securos_camera', {params})

      if (!data.success) {
        return []
      }
      commit('setData', data.data)
      return data
    },
    async get(_, {id}) {
      const {data} = await axios.get(`v1/securos_camera/${id}`)

      return data
    },
    async updateStreamConfiguration(_, params) {
      const {data} = await axios.put('v1/securos_camera/updateStreamConfiguration', params)

      return data
    },
    async updateStatus(_, {id}) {
      const {data} = await axios.get(`v1/securos_camera/update_streams/${id}`)
      return data
    },
    async add(_, params) {
      const {data} = await axios.post('v1/securos_camera', params)

      return data
    },
    async edit(_, {id, params}) {
      const {data} = await axios.put(`v1/securos_camera/${id}`, params)

      return data
    },
    async delete(_, {id}) {
      const {data} = await axios.delete(`v1/securos_camera/${id}`, {delete: 'SecurOs'})

      return data
    },
    async deleteAllCameras(_, params) {
      const {data} = await axios.get(`v1/securos_camera/deleteSecurosCameras`, {params} )

      return data
    },
    async updateDBCameras() {
      const {data} = await axios.get(`v1/mobile/updateSecurosCameras`)

      return data
    },
    async getSecurosCameras(_, params) {
      const {data} = await axios.get(`v1/mobile/get/securos_cameras`, {params})

      return data
    },
    async updateSecurosCameras(_, params) {
      const {data} = await axios.post(`v1/mobile/update/securos_cameras`, params)

      return data
    },
    clear({commit}) {
      commit('setData', [])
    }
  },
}
